module.exports = __webpack_public_path__ + "img/mapa.6a92581e.png";